import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Modal } from "react-bootstrap";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { contactUsList, deleteContactUs } from "../../common/api";
import { ShowToast } from "../../common/function";
import { Sentry, Spinner } from "react-activity";

export default function Contact() {
  const [searchText, setSearchText] = useState("");
  const [contactData, setContactData] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setShow(false);
    setSelectedId("");
  };

  const handleShow = (id) => {
    setSelectedId(id);
    setShow(true);
  };

  const getContacts = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const res = await contactUsList(token, {});
    if (res.success) {
      setContactData(res.body);
      setLoading(false);
    } else {
      ShowToast(0, res.message);
    }
  };
  const getStatusStyle = (status) => {
    switch (status) {
      case "0":
        return {
          backgroundColor: "rgba(40, 199, 111, 0.12)",
          color: "#28c76f",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
        
      case undefined:
        return {
          backgroundColor: "rgba(255, 0, 0, 0.12)",
          color: "#ff0000",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };  
      default:
        return {};
    }
  };

  useEffect(() => {
    getContacts();
  }, []);

  const handleDelete = async () => {
    const token = localStorage.getItem("token");
    setIsLoading(true)
    const res = await deleteContactUs(token, { contactUsId: selectedId });
    setIsLoading(false)
    if (res.success) {
      ShowToast(1, "Contact deleted successfully");
      getContacts();
      handleClose();
    } else {
      ShowToast(0, res.message || "Failed to delete contact");
    }
  };

  const columns = [
    {
      name: "Sr. No.",
      selector: (row, index) => index + 1,
      width: "100px",
      sortable: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Name",
      minWidth: "220px",
      selector: (row) => row.user_id?.full_name,
      sortable: true,
      cell: (row) => <>{row.user_id?.full_name || "N/A"}</>,
    },
    {
      name: "Email",
      minWidth: "130px",
      selector: (row) => row.user_id?.email,
      sortable: true,
      cell: (row) => <>{row.user_id?.email || "N/A"}</>,
    },

    {
      name: "Description",
      minWidth: "250px",
      selector: (row) => row.message,
      sortable: true,
      cell: (row) => (
        <div
          style={{
            maxHeight: "100px",
            overflowY: "auto",
            whiteSpace: "pre-wrap",
            paddingRight: "8px"
          }}
        >
          {row.message || "N/A"}
        </div>
      ),
    },
    {
      name: "User Status",
      minWidth: "190px",
      selector: (row) => row?.user_id?.is_deleted,
      sortable: true,
      cell: (row) => (
        <>
                  <span style={getStatusStyle(row?.user_id?.is_deleted)}>
                  {row?.user_id?.is_deleted == "0" ? "Active" : row?.user_id==null?"Deleted":"N/A"}
        </span>
        </>
      ),
    },

    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link className="btndelete" onClick={() => handleShow(row._id)}>
            <Icon icon="tabler:trash" />
          </Link>
        </>
      ),
    },
  ];

  const filteredData = contactData.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(searchText.toLowerCase()) !== -1
  );

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="py-4">
              <h5>Contacts</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              {loading ? ( <Sentry
                  color="#2B5AAC"
                  size={30}
                  speed={1}
                  animating={true}
                  style={{ marginLeft: "45%" }}
                />
              ) : (
                <DataTable
                columns={columns}
                data={filteredData}
                pagination
                responsive
                className="custom-table"
              />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Delete Modal */}
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            variant="outline-danger"
            onClick={handleClose}
            className="px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="px-4 min_width110"
            onClick={handleDelete}
            disabled={isLoading}
          >
            {isLoading ? (
              <Spinner animation="border" variant="success" size={15} />
            ) : (
              "Ok"
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
